// Merged application pack (was core.js + full.js)
// core.js imports
import { Turbo } from "@hotwired/turbo-rails"
import 'jquery'
import { browserBotClassifier } from '../vpsb/lib/browser_bot_classifier';

browserBotClassifier.start();
document.addEventListener('turbo:load', () => browserBotClassifier.start());


import '../stylesheets/bs4-core.scss'

// full.js imports
import '../vpsb/global';
import '../vpsb/all_pages';

import '@selectize/selectize';
window.Popper = require('popper.js').default;
import 'bootstrap';

import '../vpsb/lib/errors_collector';
import '../vpsb/google_analytics';
import '../vpsb/cookie_manager';
import '../vpsb/referral_manager';
import '../vpsb/devise';
import '../vpsb/provider_registration';
import '../vpsb/labs_correlation';
import '../vpsb/labs_test_chart';
import '../vpsb/plans';
import '../vpsb/announcements';
import '../vpsb/home';
import '../vpsb/hosters';
import '../vpsb/hoster_alternatives';
import '../vpsb/hoster_filter';
import '../vpsb/trials';
import '../vpsb/trials_index';
import '../vpsb/trials_sysbench';
import '../vpsb/screener';
import '../vpsb/storage_prices';
import '../vpsb/orders';
import '../vpsb/email_subscription';
import '../vpsb/announcement_bar';
import '../vpsb/checkout';
import '../vpsb/product';
import '../vpsb/labs_correlation';
import '../vpsb/best_vps';
import '../vpsb/compare_all';
import '../vpsb/compare_endurance';
import '../vpsb/compare_test_groups';
import '../vpsb/comparison';
import '../vpsb/compare_remote';
import '../vpsb/compare_features';
import '../vpsb/compare_yabs';
import '../vpsb/compare_managed_vps';
import '../vpsb/endurance_run';
import '../vpsb/personal_trials';
import '../vpsb/trial_remote_timing';
import '../vpsb/trial_web_runs';
import '../vpsb/yabs';
import '../vpsb/hyperscalers';
import '../vpsb/lib/yabs_table';
import '../vpsb/gpu_plans';
import '../vpsb/intelligence';

import '@selectize/selectize/dist/css/selectize.bootstrap4.css';

window.Turbo = Turbo
